/**
 * Pilot Transfer Checklist
 * Pilot boarding or disembarking
 * Regulatory: SOLAS V/23, WBC3
 */

export const PILOT_TRANSFER_CHECKLIST = {
  id: 'pilot_transfer',
  name: 'Pilot Transfer',
  description: 'Pilot boarding or disembarking',
  icon: 'UserPlus',
  regulatory: 'SOLAS V/23, WBC3',
  isCustomisable: true,
  items: [
    { id: 'pilot_1', text: 'Pilot ladder rigged and secured correctly', required: true },
    { id: 'pilot_2', text: 'Deck lighting adequate', required: true },
    { id: 'pilot_3', text: 'Lifebuoy with light at ladder', required: true },
    { id: 'pilot_4', text: 'Heaving line ready', required: true },
    { id: 'pilot_5', text: 'Crew standing by at ladder', required: true },
    { id: 'pilot_6', text: 'Bridge informed of pilot status', required: true }
  ]
};
